import { Checkbox, Typography } from '@weareopenr/component-library';
import styles from './SelectableList.module.scss';

export interface SelectableListOption {
  label: string;
  id: string;
  subtitle?: string;
}

interface SelectableListProps {
  options: SelectableListOption[];
  selectedOptions: string[];
  onChange: (selectedOptions: string[]) => void;
  className?: string;
}

const SelectableList = ({ options, selectedOptions, onChange, className }: SelectableListProps) => {
  const toggleItem = (id: string) => {
    if (selectedOptions.includes(id)) {
      onChange(selectedOptions.filter((selectedId) => selectedId !== id));
    } else {
      onChange([...selectedOptions, id]);
    }
  };

  return (
    <div className={className}>
      {options.map(({ id, label, subtitle }) => {
        const subtitleTooltip = subtitle ? subtitle.split(', ').join('\r\n') : undefined;

        return (
          <div className={styles['option-container']} key={id}>
            <Checkbox
              className={styles['checkbox']}
              labelWeight="regular"
              label={label}
              alignment="center"
              checked={selectedOptions.includes(id)}
              onChange={() => toggleItem(id)}
              data-testid={`${label}-checkbox`}
            >
              <div className={styles['label-container']}>
                <Typography size="medium" weight="regular">
                  <span>{label}</span>
                </Typography>
                {subtitle && (
                  <Typography size="xsmall" className={styles['subtitle-text']}>
                    <span title={subtitleTooltip}>{subtitle}</span>
                  </Typography>
                )}
              </div>
            </Checkbox>
          </div>
        );
      })}
    </div>
  );
};

export default SelectableList;
